var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav"},[_c('a',{staticClass:"nav__nav-link--main",class:{
      'nav__nav-link--no-margin': _vm.hasNoMargin
    },attrs:{"href":_vm.titleLink}},[_vm._v(_vm._s(_vm.title))]),_c('div',{class:{
      'nav__nav-multicolumn': _vm.multiColumn
    }},_vm._l((_vm.items),function(item){return _c('a',{key:item.name,staticClass:"nav__nav-link",attrs:{"href":item.hasAbsoluteLink ? item.link : _vm.getLinkPrefix + item.link}},[_vm._v(_vm._s(item.name))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }